"use client";

/**
 * DiscoveryBannerRow 컴포넌트
 * @description 넘김과 인디케이터는 `ImageBanner` 가 맡는다 — 여기서는 무엇을 그릴지만 정한다.
 *   데이터는 서버 컴포넌트(`DiscoveryBanner`)가 주고, 이 줄은 브라우저에서 넘김을 돌린다.
 */
import { memo, useCallback } from "react";

import DiscoveryBannerPage from "./DiscoveryBannerPage";
import type { DiscoveryBannerRowProps } from "./DiscoveryBanner.types";

import { EXPLORE_COPY } from "../../constants/copy";
import type { Banner } from "../../dtos";
import { ImageBanner, Reveal, Section } from "@/shared/ui";

/** 한 장에 머무는 시간 — 제목과 설명을 읽고 CTA 를 볼 만큼 */
const AUTOPLAY_MS = 6000;

const keyExtractor = (banner: Banner): string => String(banner.bannerId);

const DiscoveryBannerRow = memo<DiscoveryBannerRowProps>(({ banners }) => {
  const renderItem = useCallback(
    (banner: Banner, index: number) => (
      <DiscoveryBannerPage banner={banner} index={index} />
    ),
    [],
  );

  return (
    <Section padding="sm">
      <Reveal>
        <ImageBanner
          data={banners}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          label={EXPLORE_COPY.banner.label}
          autoplayMs={AUTOPLAY_MS}
        />
      </Reveal>
    </Section>
  );
});

DiscoveryBannerRow.displayName = "DiscoveryBannerRow";

export default DiscoveryBannerRow;
